import cn from 'classnames'
import { unescapeAndDecode } from 'helpers/text'
import React from 'react'
import * as styles from './styles.module.scss'

interface IInlineNotificationProps {
  type: 'success' | 'error' | 'warning'
  text?: string
  show: boolean
  onShow?: any
  onHide?: any
  isCloseable?: boolean
  containerClassName?: string
  children?: JSX.Element[] | JSX.Element | string
  avoidDangerouslySetInnerHTML?: boolean
}

interface IInlineNotificationState {
  isVisible: boolean
}

class InlineNotification extends React.Component<
  IInlineNotificationProps,
  IInlineNotificationState
> {
  static defaultProps = {
    type: 'success',
    text: '',
    show: false,
    onShow: () => null,
    onHide: () => null,
    isCloseable: false,
    containerClassName: '',
    avoidDangerouslySetInnerHTML: false,
  }

  constructor(props) {
    super(props)

    this.state = {
      isVisible: this.props.show,
    }
  }

  show = e => {
    e.preventDefault()
    this.setState({
      isVisible: true,
    })
    this.onShow()
  }

  onShow() {
    this.props.onShow()
  }

  hide = e => {
    e.preventDefault()
    this.setState({
      isVisible: false,
    })
    this.onHide()
  }

  onHide() {
    this.props.onHide()
  }

  renderContent() {
    const { text, children, avoidDangerouslySetInnerHTML } = this.props

    if (!text && !children) {
      return
    }

    if (text && avoidDangerouslySetInnerHTML) {
      return <p>{unescapeAndDecode(text)}</p>
    }

    if (text) {
      return (
        <p
          dangerouslySetInnerHTML={{
            __html: unescapeAndDecode(text),
          }}
        />
      )
    }

    if (children) {
      return children
    }
  }

  renderClose() {
    if (!this.props.isCloseable) {
      return
    }

    return <button className={styles.close} type="button" onClick={this.hide} />
  }

  render() {
    const { type, containerClassName } = this.props

    const containerClass = cn(
      styles.container,
      styles[type],
      this.state.isVisible && styles.isVisible,
      containerClassName,
    )
    const contentClass = styles.content

    return (
      <div className={containerClass}>
        <div className={contentClass}>
          {this.renderContent()}

          <span className={styles.icon} />
        </div>

        {this.renderClose()}
      </div>
    )
  }
}

export default InlineNotification
